import { render, staticRenderFns } from "./RsaPazientePrescrizioneElastomeroComponent.vue?vue&type=template&id=75e7879e&scoped=true"
import script from "./RsaPazientePrescrizioneElastomeroComponent.vue?vue&type=script&lang=js"
export * from "./RsaPazientePrescrizioneElastomeroComponent.vue?vue&type=script&lang=js"
import style0 from "./RsaPazientePrescrizioneElastomeroComponent.vue?vue&type=style&index=0&id=75e7879e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75e7879e",
  null
  
)

export default component.exports